import { Vector2 } from 'three'
import { Spring } from './Spring'

export class SpringVector2 {
  private readonly x: Spring
  private readonly y: Spring

  public readonly vector: Vector2

  constructor(vector = new Vector2(), stiffness?: number, damping?: number, mass?: number) {
    this.x = new Spring(vector.x, stiffness, damping, mass)
    this.y = new Spring(vector.y, stiffness, damping, mass)
    this.vector = vector.clone()
  }

  public setFromVector2(vector: Vector2, immediate = false) {
    this.x.setTarget(vector.x, immediate)
    this.y.setTarget(vector.y, immediate)
  }

  public update(delta: number): void {
    this.x.update(delta)
    this.y.update(delta)

    this.vector.set(this.x.value, this.y.value)
  }
}
